<template>
  <div class="row" id="table-hover-animation">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Kategoriyalar</h4>
          <button @click="addCategories" type="button" class="btn btn-primary waves-effect waves-light">
            Qo'shish
          </button>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" style="width: 30%"><h5><b>Rasm</b></h5></th>
                  <th scope="col" style="width: 30%"><h5><b>Nomlanishi</b></h5></th>
                  <th scope="col" style="width: 30%"><h5><b>Tekst</b></h5></th>
                  <th scope="col"><h5><b>Nishon</b></h5></th>
                  <th scope="col" class="text-center"><h5><b>Amaliyotlar</b></h5></th>
                </tr>
                </thead>
                <transition name="fade">
                  <tbody class="table-bordered" v-if="loaded">
                  <tr v-for="(categoryItem, categoryKey) in categories" v-bind:key="categoryKey">
                    <th scope="row">{{ categoryKey + 1 }}</th>
                    <td>
                      <img :src="`${baseURL}${categoryItem.picture}`" alt="" height="60px">
                    </td>
                    <td>
                      <a class="btn-link">{{ categoryItem.name }}</a>
                    </td>
                    <td>{{ categoryItem.comment }}</td>
                    <td>{{ categoryItem.norm }}</td>
                    <td class="d-flex justify-content-center">
                      <button class="btn btn-icon rounded-circle btn-flat-info"
                              title="Tahrirlash"
                              @click="editCategories(categoryItem)">
                        <i style="font-size: 1.5rem" class="feather icon-edit"/>
                      </button>
                      <button class="btn btn-icon rounded-circle btn-flat-danger"
                              title="O'chirish"
                              @click="deleteCategories(categoryItem.id)">
                        <i style="font-size: 1.5rem" class="feather icon-trash-2"/>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </transition>
              </table>
            </div>
          </div>

          <div class="d-flex justify-content-center" v-if="false">
            <v-pagination
                v-model="currentPage"
                :classes="bootstrapPaginationClasses"
                :page-count="totalSize"
            />
          </div>
        </div>
      </div>
    </div>
    <Modal :modal="modal"
           @modal-closed="modal = false"
           :modal-size="modalSize">
      <category-form v-if="modal && deleteApi === ''"
                     :category="category"
                     @saved="getCategories(currentPage - 1)"/>

      <deleting-modal v-if="modal && deleteApi !== ''"
                      :delete-api="deleteApi"
                      @deleted="getCategories(currentPage - 1)"/>
    </Modal>
  </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
import Modal from "../../components/Modal";
import categoryForm from "./CategoryForm";
import DeletingModal from "../../components/DeletingModal";

export default {
  name: "categoriesList",

  data() {
    return {
      categories: [],
      category: {},
      loaded: false,
      deleteApi: '',
      modal: false,
      modalSize: '',
      totalSize: 1,
      currentPage: 1,
      skip: null,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
    }
  },
  components: {
    DeletingModal,
    categoryForm,
    Modal,
    vPagination,
  },
  methods: {
    getCategories(skip = 0) {
      this.loaded = false;
      this.$api.get(`admin/Reference/GetAllCategory?skip=${skip}&take=100`)
          .then(res => {
            if (!res.error) {
              this.categories = res.result.data;
              this.totalSize = Math.ceil(res.result.total / 10);
            }
          })
          .catch(err => {

          })
          .finally(() => {
            this.loaded = true;
          })
    },
    addCategories() {
      this.category = this.createCategoryObject();
      this.modal = true;
      this.modalSize = 'modal-lg';
      this.deleteApi = '';
    },
    editCategories(category) {
      this.category = this.createCategoryObject(category);
      this.modal = true;
      this.modalSize = 'modal-lg';
      this.deleteApi = '';
    },
    deleteCategories(categoryId) {
      this.modal = true;
      this.modalSize = 'modal-sm';
      this.deleteApi = `admin/category/Delete/${categoryId}`;
    },
    createCategoryObject(category = null) {
      if (category)
        return {
          id: category.id,
          name: category.name,
          displayOrder: category.displayOrder,
          picture: category.picture,
          comment: category.comment
        };
      else
        return {
          id: 0,
          name: '',
          displayOrder: null,
          picture: null,
          comment: '',
        }
    },
  },
  watch: {
    currentPage() {
      this.getCategories(this.currentPage - 1);
    }
  },
  created() {
    this.getCategories()
  },
}
</script>
